








import Vue from 'vue';
import { getAssetPath } from '@/helpers/assets';

export default Vue.extend({
  computed: {
    arrow() {
      return getAssetPath('img/arrow.svg');
    },
  },
});
